<card-default [title]="(bondName | translate) + ' ' + bond.suretyCode" [style]="cardStyle" [showFooter]="false">
  <div>
    <div *ngIf="bond.referenceNumber" class="row" [ngClass]="{ 'mb-1': bond.effectiveDate || bond.amount }">
      <div class="col-6 label">{{ "FORM_LABEL.REFERENCE_NUMBER" | translate }}</div>
      <div class="col-6 value">{{ bond.referenceNumber }}</div>
    </div>
    <div *ngIf="bond.effectiveDate" class="row" [ngClass]="{ 'mb-1': bond.amount }">
      <div class="col-6 label">{{ "LABELS.EFFECTIVE_DATE_TIME" | translate }}</div>
      <div class="col-6 value">{{ bond.effectiveDate | customDateByUtc }}</div>
    </div>
    <div *ngIf="bond.amount" class="row">
      <div class="col-6 label">{{ "LABELS.AMOUNT" | translate }}</div>
      <div class="col-6 value">{{ bond.amount | currency : "" : "" : "1.2-2" }}$</div>
    </div>
  </div>
  <span *ngIf="isShowStatusTag" class="bond-status" [ngClass]="{ active: bond.active, inactive: !bond.active }" header-action>
    {{ bond.active ? ("LABELS.ACTIVE" | translate | uppercase) : ("LABELS.INACTIVE" | translate | uppercase) }}
  </span>
</card-default>
